<template>
  <div class="portal-ad">
    <div class="header-wrap">
      <img src="../../assets/huanong/logo.png" alt="" />
      <i></i>
      <span>新生信息校验</span>
    </div>
    <div class="backQuery" @click="backQuery" v-show="queryShow">
      <i class="su-icon-chehui2"></i> 返回查询
    </div>
    <div class="content">
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
        :rules="rules"
        class="form-class"
        v-show="!showStuNumber"
      >
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="考生号：" prop="stuNumber">
          <el-input v-model.number="form.stuNumber"></el-input>
        </el-form-item>
        <el-form-item class="btnContent" label-width="0px">
          <el-button
            type="primary"
            round
            @click="onSubmit"
            :disabled="this.form.name !== '' ? false : true"
            >提交</el-button
          >
        </el-form-item>
      </el-form>

      <div class="stuNumberInfo" v-show="showStuNumber">
        <div class="hasData" v-show="hasData  && showStuNumber ">
          <h4>您查询的学号信息如下：</h4>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="xh" label="学号"></el-table-column>
            <!-- <el-table-column prop="password" label="密码"></el-table-column> -->
          </el-table>
          <!-- <div class="result">
              <span>学号：</span>
              <span>202125265</span>
          </div> -->
          <span class="annotation">注：初始密码为hzau+出生年月日8位数</span>
        </div>
        <div class="noData" v-show="!hasData && showStuNumber">
          <img src="../../assets/huanong/noData.png" alt="" />
          <span>很遗憾，暂未查询到您的学号相关信息！</span>
        </div>
        <div class="useLink">
          <span @click="openUrl('http://center.hzau.edu.cn/info/1072/1667.htm ')">统一身份认证使用说明</span>
          <i></i>
          <span @click="openUrl('http://center.hzau.edu.cn/info/1072/1895.htm')">华中农大微校园关注指南</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getKsInfo } from '@/api/huanong.js'
export default {
  name: "newInfoCheck",
  data() {
    return {
      showStuNumber: false,
      hasData: true,
      form: {
        name: "",
        stuNumber: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" }
        ],
        stuNumber: [
          { required: true, message: "请输入考生号", trigger: "blur" },
          { type: "number", message: "考生号必须为数字" },
        ],
      },
      tableData: [],
      queryShow: false
    };
  },
  methods: {
    onSubmit() {
    //   console.log("tijiao");
        this.handStudentInfo();
    },
    backQuery() {
      this.showStuNumber = false;
      this.queryShow = false;
    },
    handStudentInfo(){
        let data = {
            ksh: this.form.stuNumber,
            name: this.form.name
        }
        getKsInfo(data).then(res => {
            if(res.code == 0){
                // this.tableData = res.data;
                this.showStuNumber = true;
                this.queryShow = true;
                if(res.data.length !== 0){
                    this.tableData = res.data;
                    this.hasData = true
                }else{
                    this.hasData = false
                }
            }
            
        })
    },
    openUrl(url){
      window.open(url);
    }
  },
};
</script>

<style lang="scss" scoped>
.portal-ad {
  width: 100%;
  .header-wrap {
    width: 100%;
    height: 127px;
    background: url("../../assets/huanong/headBg.png") no-repeat center;
    display: flex;
    align-items: center;
    padding-left: 98px;
    img {
      width: 60px;
      height: 60px;
    }
    i {
      width: 1px;
      height: 71px;
      background: #d9dce0;
      margin: 0 30px;
    }
    span {
      font-size: 24px;
      color: #333;
    }
  }
  .backQuery {
    font-size: 14px;
    color: #0e6ccb;
    padding: 10px;
    position: absolute;
    left: 100px;
    cursor: pointer;
  }
  .content {
    width: 100%;
    min-height: calc(100vh - 127px);
    background: url("../../assets/huanong/bg.png") no-repeat center bottom;
    background-size: contain;
    display: flex;
    justify-content: center;
    align-items: center;
    .form-class {
      width: 40%;
    }
    .btnContent {
      display: flex;
      justify-content: center;
      margin-top: 234px;
      button {
        background: #2367b1;
        border-color: #2367b1;
      }
    }
    .stuNumberInfo {
      width: 30%;
      h4 {
        font-size: 18px;
        color: #333;
        margin-bottom: 20px;
      }
      /deep/ .el-table th,
      .el-table tr {
        background: #e6e6e6;
      }
      /deep/ .el-table th > .cell {
        font-size: 14ox;
        color: #707070;
      }
      .annotation {
        display: block;
        font-size: 14px;
        color: #999;
        margin-top: 45px;
      }
      .noData {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          width: 413px;
          height: auto;
          margin-bottom: 30px;
        }
        span {
          font-size: 14px;
          color: #333;
        }
      }
      .useLink {
        margin-top: 145px;
        display: flex;
        justify-content: center;
        color: #0e6ccb;
        font-size: 14px;
        i {
          width: 1px;
          height: 22px;
          margin: 0 20px;
          background: #0e6ccb;
        }
      }
    }
  }
}
/deep/ .el-input__inner {
  border-radius: 40px;
}
/deep/ .el-button--primary.is-disabled,
.el-button--primary.is-disabled:active,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:hover {
  background-color: #bdd1e7 !important;
  border-color: #bdd1e7 !important;
}
@media screen and (max-width: 1000px) {
    .portal-ad{
        .header-wrap{
            width: 100%;
            padding-left: 5%;
        }
        .backQuery{
            left: 5%;
        }
        .content{
            .form-class{
                width: 90%;
            }
            .btnContent{
                /deep/ .el-form-item__content{
                    width: 100%;
                    button{
                        width: 100%;
                    }
                }
            }
            .stuNumberInfo{
                width: 90%;
                .noData{
                    margin-top: 0;
                    img{
                        width: 68.5%;
                    }
                }
                .useLink{
                    margin-top: 140px;
                }
            }
        }
    }
}
</style>